import { RouterProvider } from 'react-router-dom'
import router from './router';
 
function Main() {
  return (
    <div>
      <RouterProvider router={router}></RouterProvider>
    </div>
  );
}
 
export default Main;